var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7bdb10b3c61528604cbe001fe38eb8714657a5ba"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["buscounchollo-prod@sentry"]={id:"7bdb10b3c61528604cbe001fe38eb8714657a5ba"};
      